export enum durationIdentifier {
  BEFORE_30_MINS = 1,
  IN_30_MINS,
  IN_15_MINS,
  OVERDUE
}
